import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedAttempts } from '../components/FailedAttempts';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferBlock } from '../components/OfferBlock';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-dark-bg selection:bg-brand-orange selection:text-white" data-id="element-182">
      <Hero data-id="element-183" />
      <OpeningHook data-id="element-184" />
      <ProblemSection data-id="element-185" />
      <FailedAttempts data-id="element-186" />
      <UniqueMechanism data-id="element-187" />
      <WhatYouGet data-id="element-188" />
      <WhoIsFor data-id="element-189" />
      <OfferBlock data-id="element-190" />
      <GuaranteeSection data-id="element-191" />
      <FinalCTA data-id="element-192" />
      <FAQSection data-id="element-193" />
      <Footer data-id="element-194" />
    </main>;
}